import React from 'react';
import { Row, Col } from 'reactstrap';
import './PlantConfigurationFormLayout.css';

function ConfigMaterialRow({
  label,
  id,
  name,
  value,
  onChange,
  errorKey,
  error,
  checkName,
  checked,
  onCheck,
  colNoName,
  colNoValue,
  onColumnNo,
  showAllColumns,
}) {
  const minCol = checked && showAllColumns ? 1 : 0;

  return (
    <>
      <label htmlFor={id} className="form-group col-sm-3 text-right mb-1">{label}</label>
      <input
        type="text"
        id={id}
        name={name}
        maxLength="10"
        onChange={onChange}
        value={value || ''}
        className="form-control col-sm-5 mb-1"
        placeholder={`Please fill the ${label.toLowerCase()} field *`}
      />
      <div className="col-sm-1 plant-config-check-wrap mb-1">
        <input
          type="checkbox"
          className="is_store"
          name={checkName}
          checked={checked || false}
          onChange={onCheck}
        />
      </div>
      <input
        type="number"
        min={minCol}
        max="20"
        id={colNoName}
        name={colNoName}
        onChange={onColumnNo}
        value={colNoValue || 0}
        className="form-control col-sm-2 mb-1"
      />
      {error?.[errorKey] && (
        <>
          <div className="w-100" />
          <strong className="form-group col-sm-12 text-center text-danger">{error[errorKey]}</strong>
        </>
      )}
    </>
  );
}

const SILO_FIELDS = [
  { label: 'Silo 1', key: 'silo_1' },
  { label: 'Silo 2', key: 'silo_2' },
  { label: 'Silo 3', key: 'silo_3' },
  { label: 'Silo 4', key: 'silo_4' },
  { label: 'Silo 5', key: 'silo_5' },
];

const BIN_FIELDS = [
  { label: 'Bin 1', key: 'bin_1' },
  { label: 'Bin 2', key: 'bin_2' },
  { label: 'Bin 3', key: 'bin_3' },
  { label: 'Bin 4', key: 'bin_4' },
  { label: 'Bin 5', key: 'bin_5' },
];

const OTHER_FIELDS = [
  { label: 'Other 1', key: 'other_1' },
  { label: 'Other 2', key: 'other_2' },
  { label: 'Admix 1', key: 'other_3' },
  { label: 'Admix 2', key: 'other_4' },
  { label: 'Other 5', key: 'other_5' },
];

function MaterialSection({
  title,
  fields,
  inputs,
  handleChange,
  isChecked,
  handleCheckboxes,
  columnNumber,
  handleColumnNo,
  error,
  showAllColumns,
}) {
  return (
    <Col xl={4} lg={12} md={12}>
      <div className="form-row table-bordered shadow p-2 my-2 border-secondary mb-3 bg-blue form-control-panel plant-config-panel">
        <h5 className="col-12 plant-config-section-title"><b>{title}</b></h5>
        {fields.map((field) => (
          <ConfigMaterialRow
            key={field.key}
            label={field.label}
            id={field.key}
            name={field.key}
            value={inputs[field.key]}
            onChange={handleChange}
            errorKey={field.key}
            error={error}
            checkName={`is_${field.key}`}
            checked={isChecked[`is_${field.key}`]}
            onCheck={handleCheckboxes}
            colNoName={`${field.key}_no`}
            colNoValue={columnNumber[`${field.key}_no`]}
            onColumnNo={handleColumnNo}
            showAllColumns={showAllColumns}
          />
        ))}
      </div>
    </Col>
  );
}

export default function PlantConfigurationFormLayout({
  inputs,
  handleChange,
  isChecked,
  handleCheckboxes,
  columnNumber,
  handleColumnNo,
  error,
  plants,
  plantSelectDisabled = false,
  isAddMode = false,
}) {
  const showAllColumns = inputs.show_all_columns === 'true';

  return (
    <Row>
      <Col xl={12} lg={12} md={12}>
        <div className="form-row table-bordered shadow p-2 my-2 border-secondary mb-3 bg-blue form-control-panel plant-config-panel">
          <label htmlFor="plant_id" className="form-group col-sm-2 text-right">Plant</label>
          <select
            id="plant_id"
            name="plant_id"
            disabled={plantSelectDisabled}
            className={`browser-default custom-select form-control col-sm-4 mandatory-form-control ${plantSelectDisabled ? '' : ''}`}
            onChange={handleChange}
            value={inputs.plant_id || ''}
            required
          >
            {isAddMode && <option value="">Please Select plant</option>}
            {plants.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          <label htmlFor="target_cycle" className="form-group col-sm-2 text-right">Target Cycle</label>
          <input
            type="number"
            id="target_cycle"
            min="1"
            max="180"
            name="target_cycle"
            onChange={handleChange}
            value={inputs.target_cycle || 1}
            className="form-control col-sm-3"
            placeholder="Please fill the target cycle."
          />

          <div className="w-100" />

          <label htmlFor="show_all_columns" className="form-group col-sm-2 text-right">Show all Columns?</label>
          <select
            name="show_all_columns"
            id="show_all_columns"
            onChange={handleChange}
            value={inputs.show_all_columns || false}
            className="browser-default custom-select form-control col-sm-4 mandatory-form-control"
            required
          >
            {isAddMode && <option value="">Please select</option>}
            <option value="false">No</option>
            <option value="true">Yes</option>
          </select>
          <label htmlFor="add_extra_columns" className="form-group col-sm-2 text-right">Add extra Columns?</label>
          <select
            name="add_extra_columns"
            id="add_extra_columns"
            onChange={handleChange}
            value={inputs.add_extra_columns || false}
            className="browser-default custom-select form-control col-sm-3 mandatory-form-control"
            required
          >
            {isAddMode && <option value="">Please select</option>}
            <option value="false">No</option>
            <option value="true">Yes</option>
          </select>
        </div>
      </Col>

      <MaterialSection
        title="SILO"
        fields={SILO_FIELDS}
        inputs={inputs}
        handleChange={handleChange}
        isChecked={isChecked}
        handleCheckboxes={handleCheckboxes}
        columnNumber={columnNumber}
        handleColumnNo={handleColumnNo}
        error={error}
        showAllColumns={showAllColumns}
      />

      <MaterialSection
        title="AGGREGATE BINS"
        fields={BIN_FIELDS}
        inputs={inputs}
        handleChange={handleChange}
        isChecked={isChecked}
        handleCheckboxes={handleCheckboxes}
        columnNumber={columnNumber}
        handleColumnNo={handleColumnNo}
        error={error}
        showAllColumns={showAllColumns}
      />

      <Col xl={4} lg={12} md={12}>
        <div className="form-row table-bordered shadow p-2 my-2 border-secondary mb-3 bg-blue form-control-panel plant-config-panel">
          <h5 className="col-12 plant-config-section-title"><b>OTHERS</b></h5>
          {OTHER_FIELDS.map((field) => (
            <ConfigMaterialRow
              key={field.key}
              label={field.label}
              id={field.key}
              name={field.key}
              value={inputs[field.key]}
              onChange={handleChange}
              errorKey={field.key}
              error={error}
              checkName={`is_${field.key}`}
              checked={isChecked[`is_${field.key}`]}
              onCheck={handleCheckboxes}
              colNoName={`${field.key}_no`}
              colNoValue={columnNumber[`${field.key}_no`]}
              onColumnNo={handleColumnNo}
              showAllColumns={showAllColumns}
            />
          ))}
          <label htmlFor="is_admix_in_kgs" className="form-group col-sm-8 text-center mb-0">Admix in Kgs</label>
          <div className="col-sm-3 plant-config-check-wrap mb-1">
            <input
              type="checkbox"
              name="is_admix_in_kgs"
              id="is_admix_in_kgs"
              checked={isChecked.is_admix_in_kgs || false}
              onChange={handleCheckboxes}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
}
